<template>
  <div class="modifyName">
    <div class="weui-cells weui-cells_form" style="margin-top: 0;">
      <div class="weui-cell">
        <div class="weui-cell__bd">
          <input id="js_input" class="weui-input" placeholder="请输入手机号" v-model="accountData.mobile">
        </div>
      </div>
    </div>
    <div class="weui-form__opr-area" style="margin-top: 20px;">
      <a class="weui-btn weui-btn_primary" :class="{'weui-btn_disabled' : !accountData.mobile}" href="javascript:" style="width: 90%;" @click="updateMobile">确定</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modifyMobile',
  data () {
    return {
      accountData: {
        mobile: ''
      }
    }
  },
  activated () {
    this.getMyAccount()
  },
  methods: {
    getMyAccount () { // 查询用户信息
      let self = this
      self.$fly
        .request({
          method: 'post',
          url: '/h5/star/alliance2/star/guest/account/total/obtain/my/account'
        })
        .then(res => {
          if (res.success) {
            self.accountData = res.data
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    updateMobile () { // 提交手机号
      let self = this
      self.$fly
        .request({
          method: 'post',
          url: '/h5/star/alliance2/star/guest/account/update/by/mobile',
          params: {
            mobile: self.accountData.mobile
          }
        })
        .then(res => {
          if (res.success) {
            // 成功后返回
            self.$router.back()
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/mine/modify/mobile.vue